
import { Component, Prop, Vue } from 'vue-property-decorator'
import CourseCard from './CourseCard.vue'

interface Keys {
  name: string
  room: string
  instructor: string
  url: string
}

interface CourseData {
  [key: string]: Keys
}

@Component({
  components: {
    CourseCard,
  },
})
export default class Day extends Vue {
  @Prop() private day!: number

  weekDays = ['月', '火', '水', '木', '金']
  weekDaysEn = ['mon', 'tue', 'wed', 'thu', 'fri']

  dayEn = this.weekDaysEn[this.day]

  dialogVisible = false

  form = {
    name: '',
    room: '',
    instructor: '',
    url: '',
  } as Keys

  editing = ''
  courses: CourseData = {}

  created(): void {
    const store = localStorage.getItem(this.dayEn)
    if (store) {
      this.courses = JSON.parse(store)
    }
  }

  weekStyle(): string {
    return 'day-' + this.dayEn
  }

  showDialog(period: string): void {
    this.editing = period
    this.dialogVisible = true
  }

  submit(): void {
    if (this.form.name === '') this.form.name = '未設定'
    if (this.form.room === '') this.form.room = '未設定'
    if (this.form.instructor === '') this.form.instructor = '未設定'

    this.courses[this.editing] = { ...this.form }

    // localStorage
    localStorage.setItem(this.dayEn, JSON.stringify(this.courses))

    // 初期化
    this.dialogVisible = false
    this.editing = ''

    this.form.name = ''
    this.form.room = ''
    this.form.instructor = ''
    this.form.url = ''

    this.$message({
      message: '講義が追加されました。',
      type: 'success',
    })
  }

  existData(period: string): boolean {
    return period in this.courses
  }

  deleteData(period: string): void {
    this.$delete(this.courses, period)

    // localStorage
    localStorage.setItem(this.dayEn, JSON.stringify(this.courses))

    this.$message({
      message: '講義が削除されました。',
      type: 'success',
    })
  }

  updateData(): void {
    localStorage.setItem(this.dayEn, JSON.stringify(this.courses))

    this.$message({
      message: '講義情報を更新しました。',
      type: 'success',
    })
  }
}
